
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerconfigService } from './core/serverconfig.service';
import { timeout } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApiService { 
apiTimeout: number=100;
  constructor(public http:HttpClient,public serverconfig:ServerconfigService) {
    this.apiTimeout =ServerconfigService.serviceUrls['ApiTimeout'];
    this.apiTimeout = this.apiTimeout * 1000;
  }
 
        AddressValidation = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('SmartyStreet_API_HOST'),url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        UpdateEnrollment = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateOrUpdateEnrollment = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateEnrollment = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetEnrollmentById = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetEnrollments = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetEnrollmentsByPatientId = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        DeleteEnrollmentsByPatientId = async function(url:string, headerdata:any, data:any){
    return this.http.delete(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        DeleteEnrollment = async function(url:string, headerdata:any, data:any){
    return this.http.delete(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkUpdateEnrollments = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateOrUpdateEnrollments = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateEnrollments = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        UpdateMedicalInfo = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateOrUpdateMedicalInfo = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateMedicalInfo = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetMedicalInfosByEnrollmentId = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        DeleteMedicalInfosByEnrollmentId = async function(url:string, headerdata:any, data:any){
    return this.http.delete(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetMedicalInfoById = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        DeleteMedicalInfo = async function(url:string, headerdata:any, data:any){
    return this.http.delete(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkUpdateMedicalInfos = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateOrUpdateMedicalInfos = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetMedicalInfos = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateMedicalInfos = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkUpdateMedicineDetails = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateOrUpdateMedicineDetails = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        BulkCreateMedicineDetails = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetMedicineDetailsByPrescriptionId = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        UpdatePatientInfo = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateOrUpdatePatientInfo = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreatePatientInfo = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetPatientInfoById = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        UpdatePrescription = async function(url:string, headerdata:any, data:any){
    return this.http.put(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreateOrUpdatePrescription = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        CreatePrescription = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetPrescriptionsByEnrollmentId = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        AddEnrollment = async function(url:string, headerdata:any, data:any){
    return this.http.post(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),data, this.GetOptions$(headerdata,MediaTypes.JSON,MediaTypes.JSON)).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetEnrollmentDetails = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
        GetMasterDataByType = async function(url:string, headerdata:any, data:any){
    return this.http.get(this.getSlashedUrl( this.serverconfig.getBaseUrl('local'),'api/v1/'+url),this.GetOptions$(headerdata,MediaTypes.JSON), data).pipe(timeout(this.apiTimeout)).toPromise();
	 		}
          
    private GetOptions$(headers: any,acceptType?: string,contentType?: string) {
    const options = {
      responseType: this.getResponseType(acceptType,headers),
      observe:
        typeof headers['observe'] != 'undefined'
          ? headers['observe']
          : 'response',
    }
    delete headers["responsetype"];
    delete headers["observe"];
    headers["accept"] = acceptType;
    if (contentType) {
      if (contentType == MediaTypes.FormData) {
        headers["enctype"] = contentType;
      } else {
        headers["content-type"] = contentType;
      }
    }
    options["headers"] = new HttpHeaders(headers);
    return options;
  }
  getSlashedUrl(baseUrl: string, actionUrl: string) {
      if (baseUrl.charAt(baseUrl.length - 1) == '/' || actionUrl.charAt(0) == "/")
        return baseUrl + actionUrl;
      else
        return baseUrl + '/' + actionUrl;
  }
  private getResponseType(acceptType?: string, headers?: any) {
    switch (acceptType) {
      case MediaTypes.OctetStream:
        return typeof headers["responsetype"] != "undefined"
          ? headers["responsetype"]
          : ResponseTypes.OctetStream;
      case MediaTypes.JSON:
        return typeof headers["responsetype"] != "undefined"
          ? headers["responsetype"]
          : ResponseTypes.Json;
      case MediaTypes.Text:
        return typeof headers["responsetype"] != "undefined"
          ? headers["responsetype"]
          : ResponseTypes.Text;
      case MediaTypes.XML:
        return typeof headers["responsetype"] != "undefined"
          ? headers["responsetype"]
          : ResponseTypes.Text;
      case "default":
        return typeof headers["responsetype"] != "undefined"
          ? headers["responsetype"]
          : ResponseTypes.Json;
    }
  }
}
export enum MediaTypes {
	JSON = "application/json",
	XML = "application/xml",
	Text = "text/plain",
    FormData = "multipart/form-data",
    UrlEncoded ="application/x-www-form-urlencoded",
    OctetStream ="application/octet-stream"
}

export enum ResponseTypes {
  OctetStream = 'blob',
  Json = 'json',
  Text = 'text'
}